"use client"

import { AlignEndVertical } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AlignEndVerticalIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AlignEndVerticalIcon = component(Icon)({ as: AlignEndVertical })
